<template>
  <v-container class="pt-5">
    <v-dialog v-model="icoDialog" persistent max-width="590">
      <v-card>
        <v-card-title class="indigo white--text headline">
          {{
          $t('inconsistent_ico')
          }}
        </v-card-title>
        <v-card-text>{{ $t('chosse_one_option') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="icoDialog = false">
            {{
            $t('cont_regist')
            }}
          </v-btn>
          <v-btn color="green darken-1" flat to="/login">
            {{
            $t('login')
            }}
          </v-btn>
          <v-btn color="green darken-1" flat to="/reset">{{ $t('forgotten_password') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mx-auto" max-width="600" fill-height>
      <v-card-title class="headline font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-avatar color="primary lighten-2" class="subheading white--text" size="24" v-text="step"></v-avatar>
      </v-card-title>
      <v-layout column>
        <v-window v-model="step">
          <v-window-item :value="1">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card-text>
                <v-text-field
                  :label="$t('email')"
                  v-model="user.email"
                  :rules="emailRules"
                  required
                ></v-text-field>
                <span class="caption grey--text text--darken-1">
                  {{
                  $t('this_email')
                  }}
                </span>
              </v-card-text>
            </v-form>
          </v-window-item>

          <v-window-item :value="2">
            <v-form ref="form2" v-model="valid2" lazy-validation>
              <v-card-text>
                <v-text-field
                  :label="$t('password')"
                  :counter="0"
                  :rules="pwdRules"
                  v-model="user.passwd"
                  :append-icon="show ? 'visibility' : 'visibility_off'"
                  :type="show ? 'text' : 'password'"
                  :hint="$t('at_least_8_characters')"
                  @click:append="show = !show"
                  @blur="$refs.form2.validate()"
                  @change="$refs.form2.validate()"
                ></v-text-field>
                <v-text-field
                  :label="$t('confirm_password')"
                  v-model="match"
                  :rules="rpPwdRules"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'"
                  :hint="$t('at_least_8_characters')"
                  @click:append="show1 = !show1"
                ></v-text-field>
                <span class="caption grey--text text--darken-1">{{ $t('please_enter_pwd') }}</span>
              </v-card-text>
            </v-form>
          </v-window-item>

          <v-window-item :value="3">
            <v-form ref="form3" v-model="valid3" lazy-validation>
              <v-card-text>
                <v-alert type="error" v-model="alert" dismissible outline>
                  {{
                  errmessage
                  }}
                </v-alert>
                <v-layout row wrap>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      ref="ic"
                      :label="$t('ic')"
                      v-model="user.ic"
                      :rules="icRules"
                      @blur="checkIc"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2 mt-3">
                    <v-btn primary small @click="getAres">{{ $t('ares') }}</v-btn>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      :label="$t('name')"
                      v-model="user.name"
                      :rules="nameRules"
                      required
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      xs4
                      :label="$t('dic')"
                      v-model="user.dic"
                      placeholder="CZxxxxxxxxxx(8-10 číslic)"
                      :rules="dicRules"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field :label="$t('fname')" v-model="user.fname"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field :label="$t('surname')" v-model="user.surname"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field :label="$t('street')" v-model="user.street"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      :label="$t('house_number')"
                      v-model="user.house_no"
                      :rules="hounoRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      :label="$t('house_ref')"
                      v-model="user.house_co"
                      :rules="houcoRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      :label="$t('city')"
                      v-model="user.city"
                      :rules="cityRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field :label="$t('psc')" v-model="user.psc" :rules="pscRules" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      :label="$t('phone')"
                      v-model="user.phone"
                      :rules="phoneRules"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>
            <v-layout row wrap>
              <v-flex xs12 pl-3>
                <v-checkbox v-model="terms">
                  <template v-slot:label>
                    {{ $t('terms') }}
                    <a
                      class="pa-1"
                      target="_blank"
                      href="/api/conditions"
                      @click.stop
                      v-on="on"
                    >{{ $t('conditions') }}</a>.
                  </template>
                  >
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-window-item>

          <v-window-item :value="4">
            <div class="pa-3 text-xs-center">
              <h3 class="title font-weight-light mb-2">{{ $t('welcome') }}</h3>
              <span class="caption grey--text">{{ $t('thanks_for') }}</span>
            </div>
          </v-window-item>
        </v-window>
      </v-layout>
      <v-divider align-end></v-divider>

      <v-card-actions>
        <v-btn :disabled="step === 0 || step === 4" flat @click="stepDown">{{ $t('back') }}</v-btn>
        <v-spacer></v-spacer>
        <vue-recaptcha
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          size="invisible"
          sitekey="6LfBvaoUAAAAAPfeN8nj3-BJ_FJNW2Q2P_Ukbe-X"
          :loadRecaptchaScript="true"
        ></vue-recaptcha>
        <v-btn
          color="primary"
          depressed
          :disabled="!terms && step == 3"
          @click="checkForm"
        >{{ buttonName }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import validatation from 'validate.js'
export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      icoDialog: false,
      show: false,
      show1: false,
      valid: false,
      valid2: false,
      valid3: false,
      step: 1,
      match: '',
      user: {
        ic: '',
        dic: '',
        name: '',
        fname: '',
        surname: '',
        street: '',
        house_no: '',
        house_co: '',
        city: '',
        psc: '',
        email: '',
        passwd: '',
        phone: '',
        dph_reg: false,
        type: 'person'
      },
      emailRules: [
        v => !!v || this.$t('email_is_required'),
        v =>
          !validatation({ from: v }, this.constraints) ||
          this.$t('email_must_be_valid') ///.+@.+/.test(v)
      ],
      pwdRules: [
        v => !!v || this.$t('passwd_is_required'),
        v => {
          if (v.length >= 8) {
            const hasUpperCase = /[A-Z]/.test(v)
            const hasLowerCase = /[a-z]/.test(v)
            const hasNumbers = /\d/.test(v)
            const hasNonalphas = /\W/.test(v)
            if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3) {
              return this.$t('passwd_must_contains')
            } else {
              return true
            }
          } else {
            return this.$t('passwd_is_short')
          }
        }
      ],
      rpPwdRules: [
        v => !!v || this.$t('passwd_is_required'),
        v => v === this.user.passwd || this.$t('password_do_not_match')
      ],
      icRules: [
        v => !!v || this.$t('ico_is_required'),
        v => /\d/.test(v) || this.$t('only_digits'),
        v => !(v.length > 8) || this.$t('field_is_too_long')
      ],
      dicRules: [
        v => /^CZ\d{8,10}$|^$/.test(v) || this.$t('vat_invalid_format')
      ],
      nameRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      streetRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      hounoRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 10) || this.$t('field_is_too_long'),
        v => /\d/.test(v) || this.$t('only_digits')
      ],
      houcoRules: [v => !(v.length > 10) || this.$t('field_is_too_long')],
      cityRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      pscRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 6) || this.$t('field_is_too_long'),
        v => /\d/.test(v) || this.$t('only_digits')
      ],
      phoneRules: [],
      constraints: {
        from: {
          email: true
        }
      },
      terms: false,
      errmessage: '',
      alert: false
    }
  },

  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return this.$t('signup')
        case 2:
          return this.$t('create_a_password')
        case 3:
          return this.$t('input_data')
        case 4:
          return this.$t('account_created')
        default:
          return this.$t('signup')
      }
    },
    buttonName() {
      switch (this.step) {
        case 3:
          return this.$t('register')
        case 4:
          return this.$t('login')
        default:
          return this.$t('next')
      }
    }
  },
  mounted() {
    this.resetRecaptcha()
    this.valid = validatation({ from: this.user.Email }, this.constraints)
  },
  methods: {
    async getAres() {
      if (!this.user.ic) {
        this.errmessage = this.$t('ic_msg')
        this.alert = true
        setTimeout(() => {
          this.alert = false
        }, 5000)
        return
      }
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(`/api/ares/ico/${this.user.ic}/`)
        Object.assign(this.user, res.data)
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    stepDown() {
      this.step--
      this.$refs.form.resetValidation()
      if (this.step < 1) {
        this.$router.push('/login')
      }
    },
    checkForm() {
      switch (this.step) {
        case 1:
          if (!this.$refs.form.validate()) {
            return
          } else {
            this.step++
          }
          break
        case 2:
          if (!this.$refs.form2.validate()) {
            return
          } else {
            this.step++
          }
          break
        case 3:
          if (!this.$refs.form3.validate()) {
            return
          } else {
            this.onSubmit()
          }
          break
        case 4:
          this.$router.push('/login')
          break
        default:
          return
      }
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$refs.invisibleRecaptcha.execute()
      }
    },
    async checkIc() {
      if (!this.user.ic) {
        return
      }
      this.$root.$loader(true)
      try {
        await this.axios.get(
          this.$providerURL + `/Api/Partner/VerifyICO?ICO=${this.user.ic}`
        )
        return true
      } catch (error) {
        this.icoDialog = true
        this.user.ic = ''
        return false
      } finally {
        this.$root.$loader(false)
      }
    },
    async onVerify(response) {
      this.$root.$loader(true)
      try {
        let res = await this.axios.post('/api/captcha/verify/', {
          token: response
        })
        if (res.data.check) {
          await this.registerUser()
        }
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    onExpired() {
      console.log('Expired')
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    },
    async registerUser() {
      let id = null
      this.$root.$loader(true)
      try {
        id = await this.$http.get(this.$providerURL + '/Api/Access/GetNewId')
      } catch (error) {
        this.user.ic = ''
        this.$root.$gerror(error.response.data)
      }

      try {
        let resp = await this.$http.post(
          this.$providerURL + '/Api/Partner/RegisterPartner',
          {
            UserPassword: this.user.passwd,
            RegistrationCode: id.data,
            RegistrationUrl:
              this.$uiURL + `/finish_registration?registrationCode=${id.data}`,
            Id: id.data,
            ICO: this.user.ic,
            DIC: this.user.dic,
            Name: this.user.name,
            Street: this.user.street,
            DescNumber: this.user.house_no,
            RefNumber: this.user.house_co,
            City: this.user.city,
            ZipCode: this.user.psc,
            CountryName: 'CZ',
            Type: this.user.type || 'person',
            Email: this.user.email,
            Phone: this.user.phone,
            IsVatPayer:
              this.user.dph_reg || this.user.dic.lenght > 10 ? true : false,
            LanguageName: 'CZ',
            UserFirstName: this.user.fname,
            UserLastName: this.user.surname,
            IsDealer: false
          }
        )
        if (resp.status === 200) {
          this.step++
        }
      } catch (error) {
        this.step = 1
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    }
  }
}
</script>
